import ReactMarkdown from 'react-markdown'
import remarkMath from 'remark-math'
import rehypeKatex from 'rehype-katex'
import remarkGfm from 'remark-gfm'
import 'katex/dist/katex.min.css'

interface MarkdownRendererProps {
  content: string
  className?: string
}

export default function MarkdownRenderer({ content, className = '' }: MarkdownRendererProps) {
  return (
    <div className={`prose prose-sm prose-invert max-w-none
      [&_h1]:text-base [&_h1]:font-bold [&_h1]:text-qcloud-text [&_h1]:mt-3 [&_h1]:mb-2
      [&_h2]:text-sm [&_h2]:font-bold [&_h2]:text-qcloud-text [&_h2]:mt-3 [&_h2]:mb-1.5
      [&_h3]:text-xs [&_h3]:font-semibold [&_h3]:text-qcloud-text [&_h3]:mt-2 [&_h3]:mb-1
      [&_p]:text-xs [&_p]:text-qcloud-muted [&_p]:my-1.5 [&_p]:leading-relaxed
      [&_ul]:text-xs [&_ul]:text-qcloud-muted [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:my-1
      [&_ol]:text-xs [&_ol]:text-qcloud-muted [&_ol]:list-decimal [&_ol]:pl-5 [&_ol]:my-1
      [&_li]:my-0.5 [&_li]:leading-relaxed
      [&_strong]:text-qcloud-text [&_strong]:font-semibold
      [&_em]:italic
      [&_code]:text-[11px] [&_code]:bg-qcloud-bg [&_code]:px-1 [&_code]:py-0.5 [&_code]:rounded [&_code]:text-green-400 [&_code]:font-mono
      [&_pre]:bg-qcloud-bg [&_pre]:rounded-lg [&_pre]:p-3 [&_pre]:my-2 [&_pre]:overflow-x-auto [&_pre]:text-[11px]
      [&_pre_code]:bg-transparent [&_pre_code]:p-0 [&_pre_code]:text-qcloud-muted
      [&_blockquote]:border-l-2 [&_blockquote]:border-qcloud-primary/40 [&_blockquote]:pl-3 [&_blockquote]:my-2 [&_blockquote]:italic [&_blockquote]:text-qcloud-muted
      [&_table]:text-xs [&_table]:w-full [&_table]:my-2
      [&_th]:text-left [&_th]:px-2 [&_th]:py-1 [&_th]:border-b [&_th]:border-qcloud-border [&_th]:text-qcloud-text [&_th]:font-semibold
      [&_td]:px-2 [&_td]:py-1 [&_td]:border-b [&_td]:border-qcloud-border/50 [&_td]:text-qcloud-muted
      [&_hr]:border-qcloud-border [&_hr]:my-3
      [&_a]:text-blue-400 [&_a]:underline [&_a]:hover:text-blue-300
      ${className}`}
    >
      <ReactMarkdown
        remarkPlugins={[remarkMath, remarkGfm]}
        rehypePlugins={[rehypeKatex]}
      >
        {content}
      </ReactMarkdown>
    </div>
  )
}
